import { render, staticRenderFns } from "./SendValidation.vue?vue&type=template&id=7ad96f4c&scoped=true"
import script from "./SendValidation.vue?vue&type=script&lang=js"
export * from "./SendValidation.vue?vue&type=script&lang=js"
import style0 from "./SendValidation.vue?vue&type=style&index=0&id=7ad96f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad96f4c",
  null
  
)

export default component.exports